import WarningRoundedIcon from '@mui/icons-material/WarningRounded'
import { styled } from '@mui/material'
import Tooltip from '../tooltips/Tooltip'
import { colorPalette } from '../../style/colorPalette'

type Props = {
  message: string
  className?: string
}

export const StaleIndicatorIcon = ({ message, className }: Props) => (
  <Tooltip message={message}>
    <StyledWarningIcon className={className} />
  </Tooltip>
)

const StyledWarningIcon = styled(WarningRoundedIcon)({
  color: colorPalette.yellow[3],
  fontSize: '16px',
  flexShrink: 0,
})
